/**
 * CompanyLink — a company name that opens its company page on the Health tab (SF-5095).
 */
import { Link } from 'react-router-dom';
import { companyHealthPath } from './usageNumbers';

export interface CompanyLinkProps {
  companyId: string;
  name: string;
}

export const CompanyLink: React.FC<CompanyLinkProps> = ({ companyId, name }) => (
  <Link to={companyHealthPath(companyId)}>{name || companyId}</Link>
);
